import { imax } from '../math/fixed.ts';
import type { BattleState } from '../types.ts';
import { ev } from './combat.ts';

/**
 * The clan's call (El Cuerno 4, docs/SAGAS.md): Ulla blows the hunting horn, the clan's call to come home. Ragna
 * fights as hard as ever, but at half her life she hears it and kneels: nothing lands on her any more, the whole
 * field goes still a moment, and the fight ends without her falling.
 */

export const callTick = (s: BattleState): void => {
  const r = s.rules?.call;
  if (!r || !s.started || s.call || s.result !== 'running') return;
  const e = s.bossId ? s.enemies.find((x) => x.id === s.bossId && x.hp > 0) : undefined;
  if (!e || e.hp * 10000 > e.maxHp * r.atBp) return;
  s.call = { t: s.tick, id: e.id };
  if (e.un) {
    e.un.cast = 0;
    e.un.busy = 0;
    e.un.spots = [];
    e.un.flee = 0;
  }
  // Everything stops to hear it: the nightmares too.
  for (const o of s.enemies) if (o.hp > 0) o.stun = imax(o.stun, r.kneel + 12);
  e.anim = 'idle';
  e.animT = 0;
  ev(s, { t: 'call', id: e.id, x: e.x, y: e.y });
};

/** She kneels: nothing lands on her. */
export const callSpared = (s: BattleState, id: number): boolean => s.call?.id === id;

/** Won once she has knelt a moment (the renderer shows it). */
export const callResult = (s: BattleState): 'won' | null => {
  const r = s.rules?.call;
  return r && s.call && s.tick - s.call.t >= r.kneel ? 'won' : null;
};
